module.exports = __webpack_public_path__ + "img/heguihefa.ca4caf53.png";